import { z } from "zod";

export function rublesToKopecks(rubles: number): number {
  return Math.round(rubles * 100);
}

export type ExtractedLine = {
  name: string;
  sku: string | null;
  qty: number;
  priceKopecks: number;
  sumKopecks: number;
};

export type ExtractedReceipt = {
  supplierName: string;
  supplierInn: string | null;
  number: string | null;
  date: string | null;
  lines: ExtractedLine[];
};

// Одна оптовая единица приходной строки. price/sum — рубли (модель), конвертим в копейки.
const rawLineSchema = z.object({
  name: z.string().trim().min(1),
  sku: z.string().trim().min(1).nullable().catch(null).default(null),
  qty: z.number().int().positive(),
  price: z.number().nonnegative(),
  sum: z.number().nonnegative(),
});

// z.object по умолчанию ОТБРАСЫВАЕТ незнакомые ключи — это и есть код-граница prompt-injection:
// любое лишнее поле «system»/«exec» из ответа модели молча исчезает; строковые поля остаются
// данными (никогда не исполняются). Обязательные числовые поля строгие → битые данные падают громко.
export const extractedReceiptSchema = z
  .object({
    supplier_name: z.string().trim().min(1),
    supplier_inn: z.string().trim().regex(/^\d{10,12}$/).nullable().catch(null).default(null),
    number: z.string().trim().min(1).nullable().catch(null).default(null),
    date: z.string().trim().regex(/^\d{4}-\d{2}-\d{2}$/).nullable().catch(null).default(null),
    lines: z.array(rawLineSchema).min(1),
  })
  .transform((r): ExtractedReceipt => ({
    supplierName: r.supplier_name,
    supplierInn: r.supplier_inn,
    number: r.number,
    date: r.date,
    lines: r.lines.map((l) => ({
      name: l.name,
      sku: l.sku,
      qty: l.qty,
      priceKopecks: rublesToKopecks(l.price),
      sumKopecks: rublesToKopecks(l.sum),
    })),
  }));
